module.exports = __webpack_public_path__ + "assets/img/Slice 164(2).6ea10087.png";